import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-scroll';

const Navbar = () => {

    const [nav, setNav] = useState(false);

    const links = [
        { id: 1, link: 'home', name: 'home' },
        { id: 2, link: 'about', name: 'about' },
        { id: 3, link: 'portfolio', name: 'portfolio' },
        { id: 4, link: 'experience', name: 'experience' },
        { id: 5, link: 'certificate', name: 'certificate' },
        { id: 6, link: 'contact', name: 'contact' },
        { id: 7, link: '/Dagim Asnake Resume.pdf', name: 'Resume' }
    ];

    return (
        <div className='flex justify-between items-center w-full h-20 px-4 text-white bg-black fixed'>
            <div>
                <h1 className='text-5xl font-signature ml-2'>Dagim</h1>
            </div>

            <ul className='hidden md:flex'>
                {links.map((link) => (
                    <li key={link.id} className='px-4 cursor-pointer capitalize font-medium text-gray-500 hover:scale-105 duration-200'>
                        {link.name === 'Resume' ? (
                            <a href={link.link} download className='cursor-pointer capitalize font-medium text-gray-500 hover:scale-105 duration-200'>{link.name}</a>
                        ) : (
                            <Link to={link.link} smooth duration={500}>{link.name}</Link>
                        )}
                    </li>
                ))}
            </ul>

            <div onClick={() => setNav(!nav)} className='cursor-pointer pr-4 z-10 text-gray-500 md:hidden'>
                {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
            </div>

            {nav && (
                <ul className='flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500'>
                    {links.map((link) => (
                        <li key={link.id} className='px-4 cursor-pointer capitalize py-6 text-4xl'>
                            {link.name === 'Resume' ? (
                                <a href={link.link} download className='cursor-pointer capitalize text-4xl'>{link.name}</a>
                            ) : (
                                <Link onClick={() => setNav(!nav)} to={link.link} smooth duration={500}>{link.name}</Link>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Navbar;
